export function saveAuth(info) {
  try {
    localStorage.setItem("userinfo", JSON.stringify(info));
  } catch (e) {
    // localStorage may be unavailable in some contexts
    console.warn("Could not persist auth to localStorage", e);
  }
}

export function getSavedUser() {
  try {
    const s = localStorage.getItem("userinfo");
    return s ? JSON.parse(s) : null;
  } catch (e) {
    return null;
  }
}

// Provide a clearAuth helper (exported) to remove stored auth values.
export function clearAuth() {
  try {
    localStorage.removeItem("userinfo");
  } catch (e) {
    console.warn("Could not clear auth from localStorage", e);
  }
}
